import { downloadWatermark } from '@/api/user/userChatTitle'
const CryptoJS = require('crypto-js')
export function downloadSingleImg(src) {


    const srcname = CryptoJS.MD5(src).toString() + '_' + '.png'
    const url = src
    if (window.android) {
        window.android.downloadImg(url)
    } else {

        var x = new XMLHttpRequest()
        if (url.indexOf('?') > -1) {
            x.open('GET', url + '&t=' + new Date().getTime(), true)
        } else {
            x.open('GET', url + '?t=' + new Date().getTime(), true)
        }

        x.responseType = 'blob'
        x.onload = function (e) {
            var url = window.URL.createObjectURL(x.response)
            var a = document.createElement('a')
            a.href = url
            a.download = srcname
            a.click()
        }
        x.send()

    }













}

export function downImageForApi(contentId, src) {
    const params = {
        contentId: contentId

    }

    downloadWatermark(params).then(res => {
        const endParams = res.data
        if (src.length == 1) {

            downloadSingleImg(src[0].indexOf('?') > -1 ? src[0] + '/' + endParams : src[0] + '?' + endParams)
        } else {
            for (const s of src) {
                setTimeout(() => {

                    downloadSingleImg(s.indexOf('?') > -1 ? s + '/' + endParams : s + '?' + endParams)
                }, 1000)
            }
        }



    })
}



// WEBPACK FOOTER //
// ./src/utils/imagedownload.js